<template>
  <form @submit.prevent="searchSubmit()" class="card shadow-sm mb-4">
    <div class="card-body">
      <div class="row">
        <div class="col mb-2">
          <input
            v-model="search"
            type="text"
            maxlength="8"
            class="form-control"
            :placeholder="placeholder"
            @keypress="onlyNumber"
          />
        </div>
        <div class="col-12 col-md-3">
          <button type="submit" class="btn btn-primary btn-block">Buscar</button>
        </div>
      </div>
      <div v-if="isIntimo" class="row">
        <div class="col">
          <div class="profile">
            <div class="profile-name">{{ fullName }}</div>
            <div class="profile-intimo"><span>Usuario intimo</span></div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: 'Ingrese DNI del cliente'
    },
    isIntimo: {
      type: Boolean,
      default: false
    },
    profileIntimo: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      search: ''
    };
  },
  computed: {
    fullName() {
      if (!this.profileIntimo) return;
      return `${this.profileIntimo.firstName} ${this.profileIntimo.lastName}`;
    }
  },
  methods: {
    searchSubmit() {
      if (this.search) {
        this.$emit('submit', this.search);
      }
    },
    onlyNumber(event) {
      event = event ? event : window.event;
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        event.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>
